import { render, staticRenderFns } from "./AUserDetailAttr.vue?vue&type=template&id=0987f503&scoped=true"
import script from "./AUserDetailAttr.vue?vue&type=script&lang=js"
export * from "./AUserDetailAttr.vue?vue&type=script&lang=js"
import style0 from "./AUserDetailAttr.vue?vue&type=style&index=0&id=0987f503&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0987f503",
  null
  
)

export default component.exports